import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=1bad5cf6"
import script from "./icon.vue?vue&type=script&lang=js"
export * from "./icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports